import {configureStore} from '@reduxjs/toolkit'
import userReducer from './user'
import dialogReducer from './dialog'

export const store = configureStore({
	reducer: {
		user: userReducer,
		dialog: dialogReducer
	}
})